import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Loading from "../../../../components/Loading";
import Menu from "../../../../components/Menu";

import api from "../../../../services/api";

const LABELS_TIPO = [
    { label: 'Defeitos', value: 'defeitos' },
    { label: 'Produção', value: 'producao' },
    { label: 'Reprocesso', value: 'reprocesso' },
    { label: 'Qualidade', value: 'qualidade' },
]

const initialState = {
    id: null,
    eficiencia: '',
    premio: '',
    tipo: ''
}

export default function AcabamentoParametro() {
    const [data, setData] = useState([]);
    const [form, setForm] = useState({...initialState});

    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const fetchData = useCallback(() => {
        setIsLoading(true);
        api.get('acabamento/parametros').then(response => {
            setData(response.data);
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
            showError(error);
            setData([]);
        });
    }, []);

    const handleDelete = (rowData) => {
        confirmDialog({
            header: "Excluir",
            message: "Você tem certeza que deseja excluir esse registro?",
            acceptLabel: 'Excluir',
            acceptClassName: 'p-button-danger',
            rejectLabel: "Cancelar",
            rejectClassName: "p-button-secondary",
            accept: () => {
                setIsLoading(true);
                api.delete(`acabamento/parametros/${rowData.id}/delete`).then(response => {
                    fetchData();
                    setIsLoading(false);
                    showSuccess(response);
                }).catch(error => {
                    setIsLoading(false);
                    showError(error);
                });
            }
        });
    }

    const handleEdit = (rowData) => {
        setIsEditing(true);
        setForm({...rowData});
        setIsVisible(true);
    }

    const handleSubmit = () => {
        if(isEditing) {
            setIsLoading(true);
            api.put(`acabamento/parametros/${form.id}/update`, form).then(response => {
                fetchData();
                onHide();
                setIsLoading(false);
                showSuccess(response);
            }).catch(error => {
                setIsLoading(false);
                showError(error);
            });
        } else {
            setIsLoading(true);
            api.post('acabamento/parametros', form).then(response => {
                fetchData();
                setIsLoading(false);
                showSuccess(response);
            }).catch(error => {
                setIsLoading(false);
                showError(error);
            });
        }
    }

    const onHide = () => {
        setIsVisible(false);
        if(isEditing) {
            setIsEditing(false);
            setForm({...initialState});
        }
    }

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    if(isLoading)
        return <Loading />

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card
                className="p-m-1"
                title="Parâmetros"
            >
                <div className="p-d-flex p-flex-row p-jc-end">
                    <Button 
                        className="p-button-success p-m-1"
                        icon="pi pi-plus"
                        onClick={() => setIsVisible(true)}
                    />
                </div>

                <Dialog
                    footer={() => (
                        <div>
                            <Button className="p-button-secondary" label="Cancelar" onClick={onHide} />
                            <Button className="p-button-success" label="Salvar" onClick={handleSubmit} />
                        </div>
                    )}
                    header="Parâmetro"
                    onHide={onHide}
                    style={{ minWidth: '30vw' }}
                    visible={isVisible}
                >
                    <div className="p-fluid">
                        <div className="p-field">
                            <label htmlFor="tipo">Tipo: </label>
                            <Dropdown 
                                onChange={e => setForm({...form, tipo: e.value })}
                                options={LABELS_TIPO}
                                placeholder=""
                                value={form.tipo}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="eficiencia">Eficiência: </label>
                            <InputText 
                                onChange={e => setForm({ ...form, eficiencia: e.target.value })}
                                type="number"
                                value={form.eficiencia}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="premio">Prêmio: </label>
                            <InputText 
                                onChange={e => setForm({ ...form, premio: e.target.value  })}
                                type="number"
                                value={form.premio}
                            />
                        </div>
                    </div>
                </Dialog>

                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    groupRowsBy="tipo"
                    responsiveLayout="scroll"
                    rowGroupMode="subheader"
                    rowGroupHeaderTemplate={(data) => (
                        <div>
                            <h3 className="p-m-2">{data.tipof}</h3>
                        </div>
                    )}
                    size="small"
                    value={data}
                >
                    <Column header="Eficiência" field="eficiencia" />
                    <Column header="Prêmio" field="premio" />
                    <Column header="Ações" body={(rowData) => (
                        <div>
                            <Button 
                                className="p-button-info p-mr-1"
                                icon="pi pi-pencil"
                                onClick={() => handleEdit(rowData)}
                                title="Clique para editar as informações de parâmetro"
                            />
                            
                            <Button 
                                className="p-button-danger p-mr-1"
                                icon="pi pi-trash"
                                onClick={() => handleDelete(rowData)}
                                title="Clique para excluir o registro"
                            />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}